import React from "react";
import * as IMAGES from "../Images";

import "./Loader.css";

class Loader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      height: this.props.height,
    };
  }

  render = () => {
    return (
      <div style={{ height: this.state.height }} className="loader-container">
        <img
          src={IMAGES.LOGO_TAG_LINE}
          alt="Gear Loader"
          style={{ width: "250px" }}
        />
        {/* <div className="loader-content">Attendance made Easy</div> */}
      </div>
    );
  };
}

export default Loader;
